import ReactDOM from "react-dom";
import { App } from "./App";

console.log("hello parcel");

const app = document.getElementById("app");
ReactDOM.render(<App />, app);